import { makeStyles, createStyles } from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next";
import { Subscriptions } from "../../../const/subscriptions";
import FormWizardButtons from "../../../yoello-lib/modules/dynamicForms/FormWizardButtons";
import EColourPanel from "../../../yoello-lib/modules/dynamicForms/interfaces/EColourPanel";
import { SubscriptionCard } from "../subscription/SubscriptionCard"
import { ISubscriptions, IVenueData } from "../types";

const useStyles = makeStyles((theme) => (
    createStyles({
        root: {
            margin: '10px'
        },
        list: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: "1.5rem"
        },
        subText: {
            fontSize: "1rem",
            color: theme.palette.text.secondary,
            marginBottom: '1.25rem'
        },
        title: {
            display: 'flex'
        },
        titleText: {
            width: '70%',
            "@media only screen and (max-width: 600px)": {
                width: '65%'
            }
        },
        comparePlans: {
            width: '30%',
            "& a": {
                marginTop: '-1rem'
            },
            "@media only screen and (max-width: 600px)": {
                width: '35%'
            },
        },
        comparePlansNoTitle: {
            "& a": {
                marginTop: '-1rem'
            },
        },
        fullTitle: {
            width: "100%"
        },
        formButtons:{
            display: "flex",
            position: "absolute",
            right: "0",
            padding:"1.25rem 3.75rem",
            
            "&>div": {
                marginLeft: "0.5rem",
            },
        },
        buttonsWrapper:{
            display: "flex",
            padding:"1.25rem 3.75rem",
            justifyContent:"end",
            "&>div": {
                marginLeft: "0.5rem",
            },
        },
        leftButton: {
            "&>*": {
                padding: "0.875rem 1.5625rem",
            }
        },
        rightButton: {
            "&>*": {
                padding: "0.875rem 1.5625rem",
            }
        },
    })
))

interface ISubscriptionForm {
    selectSubscription: (id: string | null) => void;
    selectedSubscription: string | null;
    goBack?: () => void;
    onSubmit: () => void;
    venueData?: Partial<IVenueData>;
    isLoading?: boolean;
    isDialogForm?:boolean;
}

export function SubscriptionForm({
    selectSubscription,
    selectedSubscription,
    goBack,
    onSubmit,
    venueData,
    isLoading,
    isDialogForm
}: ISubscriptionForm) {
    const classes = useStyles();
    const { t } = useTranslation();

    const SubscriptionList = useMemo(() => {
        if (!venueData) return [];
        const code = venueData?.venue_location?.value;
        //@ts-ignore
        return Subscriptions[code] || [];
    }, [venueData])
    function onClickSubscription(id: string) {
        if (selectedSubscription && selectedSubscription === id) {
            selectSubscription(null);
        } else {
            selectSubscription(id);
        }
    }
    return <div className={classes.root}>
        <div className={classes.title}>
            <div className={classes.titleText}>
                <div className={classes.subText}>
                    {t('signup.subscriptions.choosePlan')}
                </div>
            </div>
            {/* {venueData && venueData?.venue_location?.value === "GB" &&
                <div className={`${classes.comparePlans}`}>
                    <Button href="https://www.yoello.com/pricing" target="_blank"
                        variant="contained" color="secondary">
                        {t('signup.subscriptions.comparePlans')}
                    </Button>
                </div>
            } */}
        </div>

        <div className={classes.list}>
            {SubscriptionList.length > 0 ?
                SubscriptionList.map((subs: ISubscriptions) =>
                    <SubscriptionCard key={subs.id} {...subs}
                        onClick={onClickSubscription}
                        active={selectedSubscription === subs.id} />)
                : <div className={classes.subText}> {t('signup.subscriptions.noSubscriptions')}</div>}
        </div>
        <div className={isDialogForm ? classes.formButtons : classes.buttonsWrapper}>
            <FormWizardButtons
                leftButton={{
                    label: t('misc.back'),
                    type: "button",
                    onClick: goBack,
                    color: EColourPanel.DEFAULT
                }}
                rightButton={{
                    type: 'button', label: t('signup.subscriptions.buttonSelect'),
                    endIcon: <ChevronRight />,
                    disabled: isLoading || !selectedSubscription,
                    color: EColourPanel.PRIMARY, onClick: onSubmit
                }}
                leftCols={8}
                rightCols={4}
                leftButtonCustomClassName={classes.leftButton}
                rightButtonCustomClassName={classes.rightButton}
                useGrid={false}
            />
        </div>

    </div>
}